import "./SubpageStyles.css";
import SubpagesData from "./SubpagesData";
import React, { useState } from "react";
import ExperienceContainer from "./ExperienceContainer";
import {
  BsFillArrowDownCircleFill,
  BsFillArrowUpCircleFill,
  BsArrowLeftCircleFill,
  BsArrowRightCircleFill,
} from "react-icons/bs";
// import { parsePath } from "react-router-dom";

// const Subpage = (props) => {
//   // const subpagesData = SubpagesData;
//   let filteredData = SubpagesData;
//   // let filteredData = reversedData;
//   // .reverse("endDate")
//   // const type = "part-time";
//   // let cnt = 0;
//   if (props.heading === "All Experiences") {
//     filteredData = SubpagesData;
//     // cnt++;
//   } else if (props.heading === "Currently Working") {
//     filteredData = SubpagesData.filter((data) => data.type.includes("Current"));
//     // cnt++;
//   } else {
//     filteredData = SubpagesData.filter((data) =>
//       data.type.includes("Part-time")
//     );
//     // cnt++;
//   }
//   filteredData.sort((a, b) => b["endDate"] - a["endDate"]);
//   // if (cnt === 1) {
//   // filteredData = filteredData.sort("endDate");
//   // }
//   // console.log(filteredData);
//   // const filteredData = subpagesData.filter((data) => data.type === props.type);

//   // const [isExpanded, setIsExpanded] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(props.collapsed);
//   const handleHeadingClick = () => {
//     setIsExpanded(!isExpanded);
//   };
//   return (
//     <div className="subpage-container">
//       <h1 style={{ paddingTop: "1rem" }}>{props.heading}</h1>
//       <div className="collapse-header-exp">
//         <BsArrowLeftCircleFill
//           className="collapse-arrow-exp"
//           size={30}
//           style={{ color: "#fff", margin: "1rem auto" }}
//         />
//         {isExpanded ? (
//           <BsFillArrowUpCircleFill
//             className="collapse-arrow-exp"
//             onClick={handleHeadingClick}
//             size={30}
//             style={{ color: "#fff", margin: "1rem auto" }}
//           />
//         ) : (
//           <BsFillArrowDownCircleFill
//             className="collapse-arrow-exp"
//             onClick={handleHeadingClick}
//             size={30}
//             style={{ color: "#fff", margin: "1rem auto" }}
//           />
//         )}
//         <BsArrowRightCircleFill
//           className="collapse-arrow-exp"
//           size={30}
//           style={{ color: "#fff", margin: "1rem auto" }}
//         />
//       </div>
//       {isExpanded && (
//         <div
//           className={
//             isExpanded ? "collapsible expanded" : "collapsible collapsed"
//           }
//           // style={{ maxHeight: isExpanded ? "100%" : "0" }}
//         >
//           {filteredData.map((value, index) => {
//             return (
//               <ExperienceContainer
//                 key={index}
//                 title={value.title}
//                 time={value.time}
//                 company={value.company}
//                 location={value.location}
//                 text={value.text}
//               />
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Subpage;

// CHATGPT STARTS HERE

const Subpage = (props) => {
  let filteredData = SubpagesData;

  if (props.heading === "All Experiences") {
    filteredData = SubpagesData;
  } else if (props.heading === "Currently Working") {
    filteredData = SubpagesData.filter((data) => data.type.includes("Current"));
  } else {
    filteredData = SubpagesData.filter((data) =>
      data.type.includes("Part-time")
    );
  }

  filteredData.sort((a, b) => new Date(b.endDate) - new Date(a.endDate));

  const [isExpanded, setIsExpanded] = useState(props.collapsed);
  const handleHeadingClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="subpage-container">
      <h1 style={{ paddingTop: "1rem" }}>{props.heading}</h1>
      <div className="collapse-header-exp">
        {/* <BsArrowLeftCircleFill
          className="collapse-arrow-exp"
          size={30}
          style={{ color: "#fff", margin: "1rem auto" }}
        /> */}
        {isExpanded ? (
          <BsFillArrowUpCircleFill
            className="collapse-arrow-exp"
            onClick={handleHeadingClick}
            size={30}
            style={{ color: "#fff", margin: "1rem auto" }}
          />
        ) : (
          <BsFillArrowDownCircleFill
            className="collapse-arrow-exp"
            onClick={handleHeadingClick}
            size={30}
            style={{ color: "#fff", margin: "1rem auto" }}
          />
        )}
        {/* <BsArrowRightCircleFill
          className="collapse-arrow-exp"
          size={30}
          style={{ color: "#fff", margin: "1rem auto" }}
        /> */}
      </div>
      {isExpanded && (
        <div className="collapsible expanded">
          {filteredData.map((value, index) => (
            <ExperienceContainer
              key={index}
              title={value.title}
              time={value.time}
              company={value.company}
              location={value.location}
              text={value.text}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Subpage;

// CHATGPT ENDS HERE
